export default __webpack_public_path__ + "static/media/paper.fc0e0099.svg";